<template>
  <div class="btn-group btn-group-sm">
    <button class="btn btn-info" title="Detailed View"
      :class="{ '-nested-comp-open-btn': isDisplayRowVisible }"
      @click="toggleNestedComp('DisplayRow')">
      <i class="fa fa-list-ul"></i>
    </button>
    <button v-if="can_access('customer','modify')" class="btn btn-info" title="Upload Docs"
      :class="{ '-nested-comp-open-btn': isUploadDocsVisible }"
      @click="toggleNestedComp('UploadDocs')">
      <i class="fa fa-upload"></i>
    </button>
    <button v-if="(!row.approved_by && can_access('customer','modify')) || (row.approved_by && can_access('customer_approve','modify'))" class="btn btn-edit" title="Edit Customer" :class="{ '-nested-comp-open-btn': isEditCustomerVisible }" @click="showModal('edit')"><i class="fa fa-edit"></i></button>
    <button v-if="(!row.approved_by && can_access('customer','modify')) || (row.approved_by && can_access('customer_approve','modify'))" class="btn" :class="row.status?'btn-danger':'btn-success'" :title="row.status?'Inactive':'Active'" @click="showModal('delete')"><i :class="row.status?'fa fa-lock':'fa fa-unlock'"></i></button>
    <!-- <button class="btn btn-info" title="Friends"
      :class="{ '-nested-comp-open-btn': isFriendsTableVisible }"
      @click="toggleNestedComp('FriendsTable')">
      <i class="fa fa-users"></i> {{ row.friends.length }}
    </button> -->
    <b-modal ref="edit-customer-out" title="Add Customer" size="xl" hide-footer v-if="can_access('customer','modify')">
        <p class="my-4"><AddCustomerForm :rows="rowData" :forceRerender="customerFormReRender"/></p>
      </b-modal>
  </div>
</template>
<script>
import $ from 'jquery';
import common from '@/assets/js/common.js';
import AddCustomerForm from '@/components/Accounts/AddCustomerForm';
export default {
  props: ['row', 'nested','refresh'],
  components: {  AddCustomerForm },
  mixins: [common],
  data(){
    return {
      rowData:{}
    }
  },
  mounted () {
    //$(this.$el).find('button[title]').tooltip()
  },
  computed: {
    isDisplayRowVisible () {
      if (this.nested.comp !== 'DisplayRow') return
      return this.nested.visible
    },
    isFriendsTableVisible () {
      if (this.nested.comp !== 'FriendsTable') return
      return this.nested.visible
    },
    isUploadDocsVisible () {
      if (this.nested.comp !== 'UploadDocs') return
      return this.nested.visible
    },
    isEditCustomerVisible () {
      if (this.nested.comp !== 'EditCustomer') return
      return this.nested.visible
    }
  },
  methods: {
    customerFormReRender(response) {
      if(response.code==0){
        this.$refs['edit-customer-out'].hide()
        this.$toasted.success("Successfully Added",{duration:1000});
        this.refresh();
      }
    },
    toggleNestedComp (comp) {
      const { nested } = this
      if (nested.comp === comp) return nested.$toggle()
      nested.$toggle(comp, true)
    },
    showModal(action) {
      if(action=='edit'){
          this.rowData = this.duplicate(this.row);
          this.rowData.action = 'edit'
      }
      if(action=='delete'){
        if(this.row.status){
          if(confirm("Do you really want to inactive?")){
            this.rowData = this.duplicate(this.row);
            this.rowData.action = 'delete';
            this.rowData.status = 0;
          }else return;
        }else{
          this.rowData = this.duplicate(this.row);
          this.rowData.action = 'delete';
          this.rowData.status = 1;
        }
      }
      this.$refs['edit-customer-out'].show()
    },
  }
}
</script>
<style>
.-nested-comp-open-btn {
  color: #fff !important;
  background-color: #337ab7 !important;
}
dd, dt {
    line-height: 1.42857143;
}
</style>
